import React from 'react'
import redirectTo from 'utils/redirectTo'
import Toast from '../../../Common/Toast'

export interface IMeetingFailedInvitesToastProps {
  onClose: () => void
  failedEmails: string
  lastCreatedMeetingId: string
}
const MeetingFailedInvitesToast = ({
  onClose,
  failedEmails,
  lastCreatedMeetingId,
}: IMeetingFailedInvitesToastProps) => {
  return (
    <Toast variant="alert" showCloseButton={true} onClose={onClose}>
      <p>
        Meeting invitation could not be sent to participants {failedEmails}.{' '}
        <span
          className="underline hover:cursor-pointer"
          onClick={() => redirectTo(`${window.location.pathname}?details=${lastCreatedMeetingId}`)}
        >
          Click to view meeting details.
        </span>
      </p>
    </Toast>
  )
}

export default MeetingFailedInvitesToast
